'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module3Res1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3Res1, _Component);

  function Module3Res1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3Res1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3Res1.__proto__ || (0, _getPrototypeOf2.default)(Module3Res1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 3',
      title: 'The P\'s and C\'s: a helpful framework for feeding children'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module3Res1, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Helps to ',
              _react2.default.createElement(
                'strong',
                { className: styles.orangeText },
                'to divide responsibilities between children and adults '
              ),
              '- this can help to take the stress out of mealtimes'
            ),
            _react2.default.createElement(
              'h3',
              null,
              'The P\'s: Parents are encouraged to plan, prepare and provide'
            ),
            _react2.default.createElement(
              'h4',
              null,
              '1. Plan the type of foods you want to buy and have in your home'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Plan ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'when'
                  ),
                  ' the meals and snacks will be offered'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Plan ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'where'
                  ),
                  ' foods will be eaten'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Plan ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'what rules'
                  ),
                  ' should be followed in your home'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              '2. Prepare healthy food options for mealtime and snack times'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Prepare ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'options'
                  ),
                  ' that include lots of fruit and vegetables'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Where possible, ask your ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'children to help you with cooking. '
                  ),
                  'Getting children involved will increase the likelihood that they will enjoy and eat healthy foods.'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              '3. Provide healthy food options in a positive way'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It is your responsibility as a parent to allow your child the choice of ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'what and how much '
                  ),
                  'they will eat from what you provide, within reasonable limits. This doesn\'t mean they have the choice to replace healthy options with less healthy ones. For example, they can\'t choose chips instead of vegetables. However,',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'providing discrete options, eg. "Do you want your carrots round or long" '
                  ),
                  'can help children become more interested in their food by being involved in decision making in a small way.'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Children have a choice within the planned, prepared, and provided options'
                )
              )
            ),
            _react2.default.createElement(
              'h3',
              null,
              'The C\'s: Children are encouraged to choose whether, what and how much to eat'
            ),
            _react2.default.createElement(
              'h4',
              null,
              '1. Choose whether or not to eat'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'When meals and snacks are provided to children as part of a regular schedule, it\'s OK for them to choose not to eat as you can be confident that ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'they won\'t go hungry'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It is important that the child knows that choosing not to eat at one meal or snack time means they ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'won\'t have the option to eat again until the next regularly scheduled meal or snack'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              '2. Choose what to eat from a variety of healthy food options'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Encouraging your child to ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'participate in planning and preparing healthy foods'
                  ),
                  ' will increase the chances that the child will make ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'healthy food choices in future'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'If your child really likes a \'sometimes\' food, only offer that food occasionally and as a small serving'
                )
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              '3. Choose how much to eat at scheduled mealtimes and snacks'
            ),
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'When parents put food on their child\'s plate, they often put on more than the child can eat'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Make sure you ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'serve small amounts appropriate for a child of that age'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Remove any television, computer, tablet, phone or gaming distractions as they can cause children to eat too little or too much of the food provided, depending on the circumstances.'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Under this framework, ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'there is no pressure for a child to \'clean their plate\'. '
                  ),
                  'If a child chooses ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'not to finish their meal, then they will have to wait until the next scheduled meal or snack before they can eat again'
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module3Res1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module3Res1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/3/Res1.js
// module id = 1247
// module chunks = 0